import { Source } from "../components/core/multiFormatImage";

export type IProgress = {score: number, maxScore: number};
export type Course = {
    creator: string;
    description: string;
    id: string;
    image: string;
    title: string;
    results: IProgress;
}

export const enum CONTENT_ITEM_TYPE {
    MARKUP = 'markup',
    VIDEO = 'video',
    TEST = 'test',
    IMAGE = 'image',
    FILE = 'file',
};
export type TaskContentItem = {
    type: CONTENT_ITEM_TYPE;
    content?: string;
    url?: string;
    image?: {
        original: Source,
        webp: Source,
    },
    testId?: string;
    fileName?: string;
    fileType?: string;
};
export type Task = {
    id: string;
    content: TaskContentItem[];
    title: string;
    lessonId: string;
    results: IProgress,
    nextTaskId?: string;
    prevTaskId?: string;
};
export const enum IQuestionType {
    MULTI_CHOISE = 'MultiChoice',
    SINGLE_CHOISE = 'SingleChoice',

};
export type Question = {
    id: string;
    type: IQuestionType;
    content: string;
    options: {id: number, value: string}[];
};

export type Test = {
    passed: boolean;
    id: string;
    questions: Question[];
    results?: IProgress;
    retryIn: number;
    sealed: boolean;
    submissionDate: string;
};
export type TestAnswer = {
    id: string;
    isCorrect: boolean;
    choices: number[];
}

export const enum TEST_STATE {
    NOT_STARTED = 'notStarted',
    FAIL = 'fail',
    IN_PROGRESS = 'inProgress',
    SUCCESS = 'success',
    CHECKING = 'checking',
};

export type TestSubmition = {
    passed: boolean;
    id: string;
    questions: Question[];
    results?: IProgress;
    retryIn: number;
    sealed: boolean;
    submissionDate: string;
    answers: TestAnswer[];
    state: TEST_STATE,
}
export type Lesson = {
    courseId: string;
    id: string;
    title: string;
    image: string;
    description: string;
    results: IProgress;
    next: string;
}

export type TestResult =  {
    testId: string,
    answers: {id: string, choices: string}[]
};
